import API from "./axios"

// create category
export const createCategory = (data) => API.post("/create-category", data)

// get categories
export const getCategories = () => API.get("/get-categories")

// admin categories
export const getCategoriesAdmin = () => API.get("/get-categories-admin")

// update category
export const updateCategory = (data) => API.post("/update-category", data)

// delete category
export const deleteCategory = (id) =>
  API.delete("/delete-category", { data: { id } })

// check slug
export const checkCategorySlug = (data) =>
  API.post("/category-slug-availability", data)

export const getCategoryProducts = (category) => {

  return API.get(`/category-products?category=${category}`)

}